<template>
  <div class="mb-4">
    <label :for="label" class="block text-sm leading-5 font-medium text-gray-700 mb-1"
      >{{ label }} <span v-if="optional" class="text-xs text-gray-700">(optional)</span></label
    >
    <div class="mt-1 relative">
      <input
        :id="label"
        :disabled="disabled"
        autocomplete="off"
        :type="type"
        class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md field-sizing-fixed px-3 py-2"
        :placeholder="placeholder"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="$emit('blur')"
        @focus="$emit('focus')"
      />
      <span
        v-if="showClearIcon"
        class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
        @click="clearInput"
      >
        <svg
          class="h-5 w-5 text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    optional: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    type: {
      type: String,
      default: 'text',
    },
    showClearIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clearInput() {
      this.$emit('update:modelValue', '');
    },
  },
};
</script>
